const BASE = '/server/equifax_function/api';
const TOKEN_KEY = 'equifax_auth_token';

function getAuthHeaders() {
	const token = localStorage.getItem(TOKEN_KEY);
	const headers = { 'Content-Type': 'application/json' };
	if (token) headers['X-App-Token'] = token;
	return headers;
}

async function request(path, options = {}) {
	const res = await fetch(`${BASE}${path}`, {
		headers: getAuthHeaders(),
		...options
	});
	const text = await res.text();
	let data;
	try {
		data = JSON.parse(text);
	} catch {
		throw new Error(`Invalid response from ${path}: ${text.substring(0, 200)}`);
	}
	// Handle Catalyst-style errors
	if (data.status === 'failure') {
		const msg = data.data?.message || data.data?.error_code || 'Unknown error';
		throw new Error(`${path}: ${msg}`);
	}
	if (!res.ok) {
		const err = new Error(data.error || `Request failed (${res.status})`);
		err.status = res.status;
		err.data = data;
		throw err;
	}
	return data;
}

export function getSettings() {
	return request('/settings');
}

export function saveSettings(settings) {
	return request('/settings', {
		method: 'PUT',
		body: JSON.stringify(settings)
	});
}

export function getFieldMappings(type) {
	return request(`/field-mappings?type=${type}`);
}

export function saveFieldMappings(type, mappings) {
	return request('/field-mappings', {
		method: 'PUT',
		body: JSON.stringify({ type, mappings })
	});
}

export function searchCrm(crmRecordId) {
	return request('/crm/search', {
		method: 'POST',
		body: JSON.stringify({ crmRecordId })
	});
}

export function kountNao(payload) {
	return request('/kount/nao', {
		method: 'POST',
		body: JSON.stringify(payload)
	});
}

export function kountValidateOtp(payload) {
	return request('/kount/validate-otp', {
		method: 'POST',
		body: JSON.stringify(payload)
	});
}

export function kountResendOtp(payload) {
	return request('/kount/resend-otp', {
		method: 'POST',
		body: JSON.stringify(payload)
	});
}

export function equifaxReport(payload) {
	return request('/equifax/report', {
		method: 'POST',
		body: JSON.stringify(payload)
	});
}

export function createClaimsInCrm(payload) {
	return request('/crm/create-claims', {
		method: 'POST',
		body: JSON.stringify(payload)
	});
}

export function updateClientPostEquifax(payload) {
	return request('/crm/update-client-post-equifax', {
		method: 'POST',
		body: JSON.stringify(payload)
	});
}

export function getProcessedClients() {
	return request('/crm/clients/processed');
}

export function resetProcessedClient(crmRecordId) {
	return request('/crm/clients/reset-processed', {
		method: 'POST',
		body: JSON.stringify({ crmRecordId })
	});
}

export function rerunClaims(crmRecordId) {
	return request('/crm/rerun-claims', {
		method: 'POST',
		body: JSON.stringify({ crmRecordId })
	});
}

export function getClaimsPool() {
	return request('/crm/claims-pool');
}

export function deleteClaimsPoolRecord(rowId) {
	return request(`/crm/claims-pool/${rowId}`, { method: 'DELETE' });
}

export function runClaimsPoolJob() {
	return request('/crm/claims-pool/run', { method: 'POST' });
}

export function checkClientProcessed(crmRecordId) {
	return request(`/crm/clients/check-processed/${crmRecordId}`);
}

export function getAuditLogs({ search, crmRecordId, stage, status, dateFrom, dateTo, page, limit } = {}) {
	const params = new URLSearchParams();
	if (search) params.set('search', search);
	if (crmRecordId) params.set('crmRecordId', crmRecordId);
	if (stage) params.set('stage', stage);
	if (status) params.set('status', status);
	if (dateFrom) params.set('dateFrom', dateFrom);
	if (dateTo) params.set('dateTo', dateTo);
	if (page) params.set('page', page);
	if (limit) params.set('limit', limit);
	return request(`/logs?${params.toString()}`);
}
